import React from "react";
// import "./App.css";
import { ResumeChat } from "./ResumeChat";
import { ResumeChatDeepseek } from "./ResumeChatDeepseek";
import { ResumeChatDeepseekWithShow } from "./ResumeChatDeepseekWithShow";

function App() {
  return (
    <div dir="rtl" className="App">
      {/* <ResumeChat /> */}
      <ResumeChatDeepseekWithShow />
    </div>
  );
}

export default App;
